/* jshint esnext: true */

var gameplay = {

	baseSize: {
		width: 6,
		height: 10,
	},

	// A reference to the maze that is being played.
	maze: null,

	// The current width of the level.
	width: 0,

	// The current height of the level.
	height: 0,

	speed: 300,

	state: '',

	dropDistance: 256,

	minSpeed: 80,
	maxSpeed: 320,
	speedFaster: 4,
	speedBoost: 0,


	/**
	 * Reset the gameplay info so we can start a new level.
	 */
	reset: function() {

		gameData.currentLevel = 0;

		gameplay.speed = 320;
		gameplay.speedBoost = 0;

		gameData.setSpeed( gameplay.speed );

		// console.log( 'reset gameplay settings', gameData.currentLevel );

	},


	/**
	 * Start a new game.
	 *
	 * Reset the properties to their defaults.
	 */
	new: function( scene ) {

		rando.randomSeed();

		// Reset level settings.
		this.width = 0;
		this.height = 0;
		this.state = 'intro';
		this.scene = scene;

		// Setup maze.
		this.nextMaze();
		this.resize_world();

		// Reset player controls.
		moves.reset();

		// Setup character properties.
		gameCharacter.new( this.scene );
		gameCharacter.position( map.checkpoints.start, 0 );
		gameCharacter.character.y -= this.dropDistance;

		// Tween character into the world.
		this.scene.tweens.add(
			{
				targets: gameCharacter.character,
				y: '+=' + this.dropDistance,
				ease: 'Sine.easeIn',
				duration: 500,
				onComplete: () => {
					gameplay.state = 'waiting';
				}
			}
		);

	},


	/**
	 * Update the game properties based upon the gameplay state.
	 */
	update: function() {

		switch ( this.state ) {

			case 'intro':

				break;

			case 'outro':

				break;

			case 'waiting':

				controls.update( this.scene );

				break;

			case 'play':

				controls.update( this.scene );

				break;

			case 'level_complete':

				break;

			case 'level_end':

				break;

			default:

		}

	},


	/**
	 * Start the level playing.
	 */
	start: function() {

		if ( 'waiting' !== this.state ) {
			return;
		}

		moves.reset( 'D' );

		this.state = 'play';

		gameTimer.start();

		// console.log( 'gameplay start' );

	},


	/**
	 *
	 */
	end: function() {

		states.set( 'game-over' );
		gameplay.state = 'level_end';
		gameCharacter.setAnimation();

	},


	/**
	 * Complete the level and move to the next one.
	 */
	levelComplete: function() {

		this.scene.tweens.add(
			{
				targets: gameCharacter.character,
				y: '+=' + 256,
				ease: 'Sine.easeIn',
				duration: 300,
				delay: 500,
				onComplete: this.newLevel
			}
		);

		gameCharacter.animate( 'win' );

		gameTimer.pause();

		gameplay.state = 'level_complete';

	},



	newLevel: function() {

		controls.reset();

		// Change scenes last.
		game.scene.stop( 'SceneGame' );
		game.scene.start( 'SceneGame' );

	},


	/**
	 * Go to the next maze.
	 *
	 * Increments the level value. Updates the world sizes.
	 */
	nextMaze: function() {

		// Increment the current level.
		gameData.currentLevel++;

		// Calculate maze dimensions.
		this.width = this.baseSize.width + gameData.currentLevel;
		this.height = this.baseSize.height + gameData.currentLevel;

		// Setup the new maze and then add it to the scene.
		mazes.setup( this.width, this.height );
		this.maze = mazes.create( this.scene );

		// Update the displayed level value.
		$( '.value.level' ).html( gameData.currentLevel );

		// Add 5 seconds to the timer when you start a new level.
		if ( gameData.currentLevel > 1 ) {
			gameTimer.add( 5, true );
		}

	},


	/**
	 * Resize the game world.
	 * This ensures the map remains central.
	 */
	resize_world: function( padding = 16 ) {

		// Use the main game tilemap since that will have the most tiles on it.
		let layer = mazes.currentMaze.layer;

		// Work out how big the world should be.
		//
		// This uses the screen width to ensure the map is centered.
		// If the map width is less than the screen width then a bit of extra
		// space is added.
		let layer_width = Math.max( layer.width, game.scale.width );
		let layer_height = Math.max( layer.height, game.scale.height );

		// The map is offset slightly based on the size of the map against the
		// screen.
		//
		// This ensures the map isn't locked to the top left corner.
		let offset_x = 0;
		let offset_y = 0;

		if ( layer_width === game.scale.width ) {
			offset_x = Math.floor( ( layer_width - layer.width ) / -2 );
		}

		if ( layer_height === game.scale.height ) {
			offset_y = Math.floor( ( layer_height - layer.height ) / -2 );
		}

		layer_width += ( padding * 2 );
		layer_height *= 2;
		offset_x -= padding;
		offset_y -= layer_height / 4;

		console.log( 'camera bounds', offset_x, offset_y, layer_width, layer_height );

		// Set bounds.
		this.scene.cameras.main.setBounds(
			Math.floor( offset_x ),
			Math.floor( offset_y ),
			Math.floor( layer_width ),
			Math.floor( layer_height )
		);

	},

	/**
	 * Make the character move a little faster.
	 *
	 * This is cumulative. The more this function is called the faster they will
	 * move.
	 */
	faster: function() {

		this.speed -= this.speedFaster;
		this.speedBoost = this.maxSpeed / 3;

		if ( this.speed <= this.minSpeed ) {
			this.speed = this.minSpeed;
		}

		gameData.setSpeed( this.speed );

	},


	/**
	 * Get the speed per tile.
	 * This is measured in milliseconds to travel across the tile.
	 *
	 * A speed of 200 would mean it takes 200ms to travel 16 pixels.
	 */
	getSpeed: function() {

		let speed = Math.ceil( this.speed - this.speedBoost );
		speed = Math.max( speed, this.minSpeed );

		// Do this after the speed is calculated so you get one cell of full
		// speed.
		this.speedBoost = this.speedBoost * 0.75;

		// console.log( speed );

		return speed;

	},

};
